import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LinkElement } from '@els/els-react--link-element';

function SubstancePubChemReferences({ references = null, className = '' }) {
  if (!references) {
    return null;
  }

  const referenceKeys = Object.keys(references);
  if (!referenceKeys || referenceKeys.length === 0) {
    return null;
  }

  return (
    <nav className={classnames('substance-pubchem-reference-links', className)} aria-label="PubChem external substance data">
      {referenceKeys.map((title) => (
        <LinkElement data-e2e="pubchem-reference-link" key={title} href={references[title]} inline navigation isExternal>
          <span>{title}</span>
        </LinkElement>
      ))}
    </nav>
  );
}

SubstancePubChemReferences.propTypes = {
  references: PropTypes.object,
  className: PropTypes.string,
};

export default SubstancePubChemReferences;
